import type { LeaveScheduleItem } from "@/shared/types";
import { baseApi } from "./index";

export interface TeamLeaveScheduleParams {
  start_date: string;
  end_date: string;
}

export const teamLeaveScheduleApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTeamLeaveSchedule: builder.query<LeaveScheduleItem[], TeamLeaveScheduleParams>({
      query: (params) => ({
        url: `/api/self/team-leave-schedule/?start_date=${params.start_date}&end_date=${params.end_date}`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "TeamLeaveSchedule" as const, id: "LIST" }],
    }),
  }),
});

export const { useGetTeamLeaveScheduleQuery } = teamLeaveScheduleApi;
